import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'

import { formatearFecha } from '../../helpers/helper'
import * as archivoAdjuntoService from '../../servicios/archivoAdjuntoService'
import styles from './MensajeriaNew.module.css'

export const Mensaje = ({ mensaje, usuario, tipoMensajes, manejarAdjunto }) => {
  const {
    idMensaje,
    texto,
    fechaEscrito,
    textoRta,
    fechaEscritoRta,
    idUsuarioChat,
    idAdjunto,
    idsAdjuntos
  } = mensaje
  const [adjuntos, setAdjuntos] = useState([])
  const [imagenAmpliada, setImagenAmpliada] = useState(null)

  const fetchAdjunto = async (id) => {
    const { data } = await archivoAdjuntoService.buscarAdjuntosPorId(id)
    await manejarAdjunto(data, setAdjuntos, id)
  }

  useEffect(() => {
    if (idsAdjuntos) {
      const ids = idsAdjuntos.split(',').map((id) => parseInt(id.trim()))
      ids.forEach((id) => {
        if (id) {
          fetchAdjunto(id)
        }
      })
    } else if (idAdjunto && adjuntos.length === 0) {
      fetchAdjunto(idAdjunto)
    }
  }, [idsAdjuntos, idAdjunto])

  const obtenerClaseAlineado = (idUsuarioChat) =>
    usuario === idUsuarioChat && tipoMensajes === 'chat' ? styles.mensaje : styles.mensajeMio

  return (
    <div key={idMensaje}>
      {imagenAmpliada && (
        <div className={styles.overlay} onClick={() => setImagenAmpliada(null)}>
          <img alt="Imagen ampliada" src={imagenAmpliada} className={styles.overlayImg} />
        </div>
      )}
      <div className={obtenerClaseAlineado(idUsuarioChat)}>
        <p>{texto}</p>

        {adjuntos.length > 0 && (
          <span className={styles.archivoWrapper}>
            {adjuntos.map((att, idx) => (
              <span key={idx} className={styles.archivoItemWrapper}>
                {att.contentType.startsWith('image/') ? (
                  <img
                    src={att.url}
                    alt={att.nombre}
                    className={styles.imgAdjunto}
                    onClick={() => setImagenAmpliada(att.url)}
                  />
                ) : att.contentType === 'application/pdf' ? (
                  <a
                    href={att.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.archivoItem}
                  >
                    <i className="fa fa-file-pdf-o" />
                    <span>{att.nombre}</span>
                  </a>
                ) : (
                  <a href={att.url} download={att.nombre} className={styles.archivoItem}>
                    <i className="fa fa-file-o" />
                    <span>{att.nombre}</span>
                  </a>
                )}
              </span>
            ))}
          </span>
        )}

        <span className={styles.fechaMensaje}>{formatearFecha(fechaEscrito, 'FH', 'hs')}</span>
      </div>

      {textoRta && (
        <div className="ms-4 text-secondary position-relative">
          <div className={styles.respuestaFlecha}></div>
          <p className={styles.textoMensaje}>
            {textoRta}
            <span className={styles.fechaMensaje}>
              {formatearFecha(fechaEscritoRta, 'FH', 'hs')}
            </span>
          </p>
        </div>
      )}

      {tipoMensajes === 'preguntas' && <hr />}
    </div>
  )
}

Mensaje.propTypes = {
  mensaje: PropTypes.shape({
    idMensaje: PropTypes.number.isRequired,
    texto: PropTypes.string.isRequired,
    fechaEscrito: PropTypes.string.isRequired,
    textoRta: PropTypes.string,
    fechaEscritoRta: PropTypes.string,
    idUsuarioChat: PropTypes.number.isRequired,
    idAdjunto: PropTypes.number,
    idsAdjuntos: PropTypes.string,
    idVendedor: PropTypes.number.isRequired,
    comprador: PropTypes.string.isRequired,
    vendedor: PropTypes.string.isRequired
  }).isRequired,
  usuario: PropTypes.string.isRequired,
  tipoMensajes: PropTypes.string.isRequired,
  manejarAdjunto: PropTypes.func.isRequired
}
